import { Action } from "@ngrx/store";


export enum EGreenChoicesActions {
    GetShowModalMoreGreenChoices = "[GreenChoices] Get Show Modal More Green Choices",
    SetShowModalMoreGreenChoices = "[GreenChoices] Set Show Modal More Green Choices",
}

export class GetShowModalMoreGreenChoices implements Action {
    public readonly type = EGreenChoicesActions.GetShowModalMoreGreenChoices;
}

export class SetShowModalMoreGreenChoices implements Action {
    public readonly type = EGreenChoicesActions.SetShowModalMoreGreenChoices;
    constructor(public payload: boolean) {}
}

export type GreenChoicesActions = GetShowModalMoreGreenChoices | SetShowModalMoreGreenChoices;
